exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#single-sign-on-confirm-view .modal-body {\n  display: flex;\n  flex-direction: column;\n  align-items: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/modal/create-account-modal/sso-confirm-view.sass
// module id = 836
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91